import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paymentsService } from "services/payment.api";
import { selectPaymentItems } from "store/paymentSlice";
import { setPaymentItems } from "store/paymentSlice";

const usePayment = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const paymentList = useSelector(selectPaymentItems);
  const [error, setError] = useState(null);

  const getpaymentList = async (data) => {
    setLoading(true);
    try {
      const response = await paymentsService.fetchList(data);
      if (response.success) {
        dispatch(setPaymentItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const paymentPreview = async (payload) => {
    setLoading(true);
    try {
      const response = await paymentsService.previewPayments(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const paymentSync = async (payload) => {
    setLoading(true);
    try {
      const response = await paymentsService.syncPayments(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getpaymentList,
    paymentList,
    paymentPreview,
    paymentSync,
    loading,
    error,
  };
};

export default usePayment;
